(function() {
    'use strict';

    angular
        .module('app')
        .directive('drvNavigationBreadcrumbs', NavigationBreadcrumbs);

    NavigationBreadcrumbs.$inject = [];
    
    /**
     * @ngdoc directive
     * @name drvNavigationBreadcrumbs
     *
     * @description
     * Presents "breadcrumb" navigation control
     */
    function NavigationBreadcrumbs() {
        var directive = {
            link: link,
            restrict: 'E',
            templateUrl: 'app/navigation-breadcrumbs.tmpl.html',
            scope: {},
            controller: drvNavigationBreadcrumbsCtrl,
            controllerAs: 'drvCtrl',
        };
        return directive;

        function link(scope, element, attrs) {
        }
    }

    drvNavigationBreadcrumbsCtrl.$inject = ['NavigationAidService'];

    function drvNavigationBreadcrumbsCtrl(NavigationAidService) {
        /* jshint validthis:true */
        var drvCtrl = this;
        drvCtrl.crumbClick = crumbClick;
        Object.defineProperty(drvCtrl, 'breadcrumbs', { get: getBreadcrumbs });

        function getBreadcrumbs() {
            return NavigationAidService.pathHistory;
        }

        function crumbClick(crumb, $index) {
            NavigationAidService.goToIndex($index);
        }
    }
})();